export default () => {
  const forms = document.querySelectorAll('.js-add-to-cart-form')
  if (forms.length > 0) {
    ;[...forms].forEach(form => {
      form.addEventListener('submit', e => {
        const formData = new window.FormData(form)
        const data = {}
        formData.forEach((value, key) => {
          data[key] = value
        })
        window.dataLayer.push({
          event: 'addToCart',
          ecommerce: {
            add: {
              // 'add' actionFieldObject measures.
              products: [
                {
                  name: data.product_name,
                  id: data.product_id,
                  price: data.hidden_price,
                  variant: data.attribute_pa_kleur
                    ? data.attribute_pa_kleur
                    : '',
                  quantity: data.quantity,
                  category_0: data.category_0,
                  category_1: data.category_1,
                  width: data.mattador_width,
                  length: data.mattador_length,
                  rubber: data.mattador_rubber ? data.mattador_rubber : '',
                  filler_mat: data.filler_mat ? data.filler_mat : ''
                }
              ]
            }
          }
        })

        window.dataLayer.push({
          event: 'add_to_cart',
          ecommerce: {
            currency: 'EUR',
            value: data.hidden_price,
            items: [
              {
                item_name: data.product_name,
                item_id: data.product_id,
                price: data.hidden_price,
                variant: data.attribute_pa_kleur ? data.attribute_pa_kleur : '',
                quantity: data.quantity,
                category_0: data.category_0,
                category_1: data.category_1,
                width: data.mattador_width,
                length: data.mattador_length,
                rubber: data.mattador_rubber ? data.mattador_rubber : '',
                filler_mat: data.filler_mat ? data.filler_mat : ''
              }
            ]
          }
        })

        // let eventSend = false
        // if (!eventSend) {
        //   e.preventDefault()

        //   try {
        //     const formData = new window.FormData(form)
        //     const data = {}
        //     formData.forEach((value, key) => {data[key] = value});
        //     window.dataLayer.push({
        //       'event': 'addToCart',
        //       'ecommerce': {
        //         'add': {                                // 'add' actionFieldObject measures.
        //           'products': [{
        //             name: data.product_name,
        //             id: data.product_id,
        //             price: data.hidden_price,
        //             variant: data.attribute_pa_kleur ? data.attribute_pa_kleur : '',
        //             quantity: data.quantity,
        //             category_0: data.category_0,
        //             category_1: data.category_1,
        //             width: data.mattador_width,
        //             length: data.mattador_length,
        //             rubber: data.mattador_rubber ? data.mattador_rubber : ''
        //           }]
        //         }
        //       },
        //       'eventCallback': function() {
        //         eventSend = true
        //         form.submit()
        //       }
        //     });
        //   } catch(e) {
        //     console.error(e)
        //     eventSend = true
        //     form.submit()
        //   }

        // } else {
        //   form.submit()
        // }
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/js/datalayer/AddToCart.js